import { Image, ImageProps, useBreakpoint } from '@gyym/ui'
import React from 'react'

export interface SwitchImageProps {
  base: ImageProps
  tablet?: ImageProps
  pc?: ImageProps
}

export const SwitchImage = ({ base, tablet, pc }: SwitchImageProps) => {
  const { isTablet, isPc } = useBreakpoint()

  const [isBrowser, setBrowser] = React.useState(false)

  React.useEffect(() => {
    setBrowser(true)
  }, [])

  if (!isBrowser) return null

  if (isTablet) {
    const img = tablet ?? base
    return <Image {...img} alt={img.alt} sizes="100vw" />
  }

  if (isPc) {
    const img = pc ?? tablet ?? base
    return <Image {...img} alt={img.alt} sizes="100vw" />
  }

  return <Image {...base} alt={base.alt} sizes="100vw" />
}
